import React from "react";
import { StyledFormSection } from "./FormSection.styled";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum, IconSizeEnum } from "../../types/AppTypes";
import { IconManager } from "../core/IconManager/IconManager";

type FormSectionProps = {
  label: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  rightContent?: React.ReactNode;
};
export const FormSection = ({
  label,
  icon,
  children,
  rightContent,
}: FormSectionProps) => {
  return (
    <StyledFormSection>
      <div className="fs-header">
        <div className="title">
          <IconManager size={IconSizeEnum.SMALL} marginRight={10}>
            {icon}
          </IconManager>
          <BodyTyp fontWeight={FontWeightEnum.SEMIBOLD} variant="2">
            {label}
          </BodyTyp>
        </div>
        <div>{rightContent}</div>
      </div>
      <div>{children}</div>
    </StyledFormSection>
  );
};
